<template>
    <el-dialog
        title="提 示"
        :visible.sync="showMailDialog"
        width="45%"
        class="dialogShowMail"
        :before-close="handleClose">
        <p class="msg-title">请把提交时自动下载的前缀为：考试数据删除可能影响考试结果+试卷名称，后缀为.txt的恢复文件发送至该邮箱：<b>wanghaifeng@aitestgo.com</b>并标注您的姓名，证件号，考试名称信息，已用于帮助您恢复记录。</p>
        <p class="msg-value">
            <b style="font-size:17px;">邮箱：wanghaifeng@aitestgo.com</b>&nbsp;
            <span slot="reference" class="copyMail" data-clipboard-text="wanghaifeng@aitestgo.com"><el-button type="primary" @click="clickCopy" style="padding: 5px 9px;width:50px;" size="mini">复制</el-button></span>
        </p>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="showMailDialog = false">关闭</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default{
    data(){
        return {
            showMailDialog:false
        }
    },
    methods:{
        open(){
            this.showMailDialog = true
        },
        handleClose(done){
            done();
        },
        clickCopy() { 
            var clipboard = new this.Clipboard('.copyMail');  
            clipboard.on('success', e => {  
                this.$notify({
                    title: '复制成功',
                    type: 'success'
                });
                // 释放内存  
                clipboard.destroy()  
            })  
            clipboard.on('error', e => {  
                // 不支持复制
                this.$notify({
                    title: '该浏览器不支持自动复制',
                    type: 'success'
                }); 
                // 释放内存  
                clipboard.destroy()  
            })  
        },
    }
}
</script>
<style scoped lang="less">
    .msg-title{
        width: 91%;
        margin: auto;
        text-align: left;
        text-indent:2em;
        font-size: 15px;
    }
    .msg-value{
        width: 91%;
        margin: 10px auto 0;
        text-align: left;
    }
</style>
<style>
    .dialogShowMail .el-dialog{
        width: 500px !important;
        height: 300px !important;
    }
    .dialogShowMail .el-dialog__body{
        padding: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/exam2/promptMailbox.vue